import bannerMob from "../assets/img/banner_oficial_mob.webp";
import bannerDsk from "../assets/img/banner_oficial_dsk.webp";

export const GENERIC_LANDING_CONFIG = {
  firebaseDocId: "evento-ranger",
  eventName: "Ranger Day",
  introSubtitle:
    "Este 27 de Junio, realizá un Test Drive de Ranger, llevate un kit mundialista y participá por una camiseta OFICIAL para alentar a la selección.",
  emailEventName: "Ranger Day - Test Drive Montironi",
  emailjsTemplateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "",
  banners: {
    mobile: bannerMob,
    desktop: bannerDsk,
  },
};

